import moment from "moment";
import { LifeAreasState } from "../contexts/LifeAreasContext";
import { ActivityState } from "../contexts/ActivityContext";

export const isBlockCompletedToday = (
  blockId: string,
  activity: ActivityState
) => {
  const dateKey = moment().format("YYYY-MM-DD");
  if (activity[dateKey] && activity[dateKey].blocks[blockId]) return true;
  return false;
};

// Returns 7 values for the graph. 1 for each day of the week.
export const returnProgressDataForCurrentWeek = (
  activity: ActivityState,
  areasState: LifeAreasState,
  areaKey: string
) => {
  const completedBlocksCount: Array<number> = [];

  // function to extract the block activity data for a given date

  const completionCountForDate = (dateKey: string) => {
    let count = 0;
    if (!activity[dateKey]) return count;
    // If the block was completed and is selected in the area we increment the daily count.
    Object.keys(activity[dateKey].blocks).forEach((blockId: string) => {
      console.log("blockId", blockId);
      if (
        activity[dateKey].blocks[blockId] &&
        areasState.blockIds[areaKey].includes(blockId)
      ) {
        console.log("blockId affects completion");
        count++;
      }
    });
    return count;
  };

  for (let i = 0; i < 8; i++) {
    // Start of the current week
    const start = moment().startOf("week");
    const dateKey = start.add(i, "days").format("YYYY-MM-DD");
    console.log(dateKey);
    const completedCount = completionCountForDate(dateKey);
    completedBlocksCount.push(completedCount);
  }
  return completedBlocksCount;
};
